import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';

import { makeTamagoshiIcon } from '@/core/tamagoshiTailwind/util/makeTamagoshiComponent';

export const CategoryPaintingIcon = makeTamagoshiIcon((props, ref) => (
  <Svg
    height="24"
    optimizationId="tama-category-painting"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M11.1874 21.9449C12.1042 21.9449 12.8174 21.148 12.7162 20.2369L12.3349 16.8054C12.2634 16.162 12.3402 15.5108 12.5593 14.9016L12.6711 14.5907C12.7854 14.2727 12.5498 13.9377 12.212 13.9377H10.1993C9.84966 13.9377 9.6135 14.2943 9.75007 14.6162C10.0365 15.2913 10.143 16.0293 10.0592 16.7578L9.65946 20.2308C9.55431 21.1439 10.2683 21.9449 11.1874 21.9449Z"
      fillRule="evenodd"
    />
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M10.595 13.9696V12.7326C10.595 12.1518 10.9831 11.6425 11.5431 11.4886L19.2205 9.37727C19.4787 9.30626 19.6577 9.07141 19.6577 8.80353V6.36737C19.6577 6.13636 19.4703 5.94919 19.2393 5.94919H18.7405L18.8023 4.6405L19.6225 4.65555C20.3717 4.66929 20.9717 5.2806 20.9717 6.0298V8.99434C20.9717 9.73747 20.473 10.3879 19.7554 10.5807L12.7505 12.4626C12.2197 12.6053 11.8375 13.0685 11.7983 13.6168L11.7731 13.9696H10.595Z"
      fillRule="evenodd"
    />
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M4.13939 5.68508H3.57505C3.25879 5.68508 3 5.42619 3 5.10993V5.00801C3 4.69165 3.25879 4.43286 3.57505 4.43286H4.13939C4.45576 4.43286 4.71455 4.69165 4.71455 5.00801V5.10993C4.71455 5.42619 4.45576 5.68508 4.13939 5.68508Z"
      fillRule="evenodd"
    />
    <path
      className="fill-accent-primaryActive"
      clipRule="evenodd"
      d="M17.662 8.27495H4.94493C4.31703 8.27495 3.80347 7.72949 3.80347 7.06283V3.21212C3.80347 2.54545 4.31703 2 4.94493 2H17.662C18.2898 2 18.8035 2.54545 18.8035 3.21212V7.06283C18.8035 7.72949 18.2898 8.27495 17.662 8.27495Z"
      fillRule="evenodd"
    />
  </Svg>
));

CategoryPaintingIcon.displayName = 'CategoryPaintingIcon';
